import script from "./TextStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TextStylePanel.vue?vue&type=style&index=0&id=16951d2a&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16951d2a"]])

export default __exports__